import { FC, useState } from "react";
import { Grid, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";
import { SCUIButton, SCUIDateRanger } from "../../../../atomic/atoms";
import { SCUIGeneralDrawerHeader } from "../../../../atomic/molecules";
import CargoFeeManagementCommand from "../../../../services/command/cargoFeeManagement/CargoFeeManagementCommand.services";
import Swal from "sweetalert2";

import React from "react";
import { CFM, cfmCls } from "../../cargoFeeManagement.classes";

interface IProps {
  selectedRow?: any;
  setSelectedRow?: any;
  onClose?: any;
  refresh?: any;
  filterInput?: any;
  companyList?: any;
  distanceTypeList?: any;
  departureLocationList?: any;
}
export const SCUICargoFeeAdd: FC<IProps> = ({
  onClose,
  refresh,
  companyList,
  distanceTypeList,
  departureLocationList,
}) => {
  const { t } = useTranslation();
  const isActive = undefined;

  const [price, setPrice] = useState();
  const [companyId, setCompanyId] = React.useState(1);
  const [desi, setDesi] = useState();
  const [endDate, setEndDate] = useState("");
  const [createdDate, setCreatedDate] = useState("");
  const [distanceTypeId, setDistanceTypeId] = React.useState(1);
  const [departureLocationTypeId, setDepartureLocationTypeId] =
    React.useState(1);
  const _handleChangeDate = (event: any) => {
    setCreatedDate(event[0]);
    setEndDate(event[1]);
  };

  const AddCargoOrderLimit = async () => {
    if (
      Number(price) < 0 ||
      !createdDate ||
      !endDate ||
      !desi ||
      !companyId ||
      !distanceTypeId
    ) {
      Swal.fire(
        t("general.error"),
        t("cargoFeeManagement.unexpectedValue"),
        "error"
      );
      return;
    }
    let addCargoFeeRequests = [
      {
        shippingCompanyId: companyId,
        distanceTypeId: distanceTypeId,
        departureLocationTypeId: departureLocationTypeId,
        price: price,
        validStartDate: createdDate,
        validEndDate: endDate,
        desi: desi,
        isActive: isActive,
      },
    ];
    CargoFeeManagementCommand.AddCargoFee(addCargoFeeRequests)
      .then(() => {
        Swal.fire(t("general.added"), " ", "success");
        refresh();
        onClose();
      })
      .catch((error: any) => {
        console.log("Hata :>> ", error);
      });
  };
  return (
    <form
      onSubmit={(e: any) => {
        e.preventDefault();
      }}
    >
      <div className={cfmCls("commentFilterContainer", CFM.drawerAdd)}>
        {
          <Grid container spacing={1}>
            <SCUIGeneralDrawerHeader
              header={t("cargoFeeManagement.cargoFeeAdd")}
              onClose={onClose}
            />
            <Grid
              size={{
                xs: 12,
                md: 12,
                lg: 12,
                xl: 12
              }}>
              <Grid
                style={{ marginTop: "1rem" }}
                size={{
                  xs: 12,
                  md: 12,
                  lg: 12,
                  xl: 12
                }}>
                <InputLabel id="labelApp">
                  {t("cargoFeeManagement.selectCargoCompany")}
                </InputLabel>
                <Select
                  className={cfmCls(CFM.input, CFM.inputSelect, CFM.fieldAddCompany)}
                  label={t("cargoFeeManagement.selectCargoCompany")}
                  labelId="labelApp"
                  id="parentMenuLabel"
                  value={companyId}
                  onChange={(event) => {
                    setCompanyId(Number(event.target.value));
                  }}
                  fullWidth
                >
                  {companyList &&
                    companyList
                      .filter((comp: any) => comp.value !== "-1")
                      .map((comp: any) => (
                        <MenuItem
                          key={comp.value}
                          id={comp.value}
                          value={comp.value}
                        >
                          {comp.text}
                        </MenuItem>
                      ))}
                </Select>
              </Grid>
              <Grid
                style={{ marginTop: "2rem" }}
                size={{
                  xs: 12,
                  md: 12,
                  lg: 12,
                  xl: 12
                }}>
                <InputLabel id="labelApp">
                  {t("cargoFeeManagement.selectDistanceType")}
                </InputLabel>
                <Select
                  className={cfmCls(CFM.input, CFM.inputSelect, CFM.fieldAddDistance)}
                  label={t("cargoFeeManagement.selectDistanceType")}
                  labelId="labelApp"
                  id="parentMenuLabel"
                  value={distanceTypeId}
                  onChange={(event) => {
                    setDistanceTypeId(Number(event.target.value));
                  }}
                  fullWidth
                >
                  {distanceTypeList &&
                    distanceTypeList
                      .filter((comp: any) => comp.value !== "-1")
                      .map((dist: any) => (
                        <MenuItem
                          key={dist.value}
                          id={dist.value}
                          value={dist.value}
                        >
                          {dist.text}
                        </MenuItem>
                      ))}
                </Select>
              </Grid>
              <Grid
                style={{ marginTop: "2rem" }}
                size={{
                  xs: 12,
                  md: 12,
                  lg: 12,
                  xl: 12
                }}>
                <InputLabel id="labelApp">
                  {t("cargoFeeManagement.selectdeparturelocationtype")}
                </InputLabel>
                <Select
                  className={cfmCls(CFM.input, CFM.inputSelect, CFM.fieldAddDeparture)}
                  label={t("cargoFeeManagement.selectdeparturelocationtype")}
                  labelId="labelApp"
                  id="parentMenuLabel"
                  value={departureLocationTypeId}
                  onChange={(event) => {
                    setDepartureLocationTypeId(Number(event.target.value));
                  }}
                  fullWidth
                >
                  {departureLocationList &&
                    departureLocationList
                      .filter((comp: any) => comp.value !== "-1")
                      .map((dist: any) => (
                        <MenuItem
                          key={dist.value}
                          id={dist.value}
                          value={dist.value}
                        >
                          {dist.text}
                        </MenuItem>
                      ))}
                </Select>
              </Grid>
              {
                <Grid
                  style={{ marginTop: "2rem" }}
                  size={{
                    xs: 12,
                    md: 12,
                    lg: 12,
                    xl: 12
                  }}>
                  <TextField
                    id="desi"
                    defaultValue={""}
                    type="text"
                    label={t("cargoFeeManagement.desi")}
                    fullWidth
                    className={cfmCls(CFM.input, CFM.inputTextfield, CFM.fieldAddDesi)}
                    onChange={(event: any) => {
                      setDesi(event.target.value);
                    }}
                  />
                </Grid>
              }
              <Grid
                style={{ marginTop: "2rem" }}
                size={{
                  xs: 12,
                  md: 12,
                  lg: 12,
                  xl: 12
                }}>
                <TextField
                  id="price"
                  defaultValue={""}
                  type="text"
                  label={t("cargoFeeManagement.price")}
                  fullWidth
                  className={cfmCls(CFM.input, CFM.inputTextfield, CFM.fieldAddPrice)}
                  onChange={(event: any) => {
                    setPrice(event.target.value);
                  }}
                />
              </Grid>
              <Grid style={{ marginTop: "2rem" }} className={CFM.drawerAddDateRange}>
                <SCUIDateRanger
                  fromDate={""}
                  toDate={""}
                  setDateRange={_handleChangeDate}
                  dateFormat="YYYY-MM-DD"
                  fullWidth
                />
              </Grid>
            </Grid>
            <Grid
              className={CFM.drawerAddActions}
              style={{
              marginTop: "16px",
              marginBottom: "16px",
              display: 'flex',
              justifyContent: 'flex-end'
              }}
              size={{
                xs: 12,
                md: 12,
                lg: 12,
                xl: 12
              }}>
              <SCUIButton
                text={t("general.add")}
                type="primary"
                sizeType="default"
                buttonType="submit"
                size={'m'}
                style={{ width: 140 }}
                className={cfmCls(CFM.input, CFM.inputButton, CFM.btnDrawerAddSubmit)}
                onClick={AddCargoOrderLimit}
              />
            </Grid>
          </Grid>
        }
      </div>
    </form>
  );
};
